// AI Generated Pipe
import { Pipe, PipeTransform } from '@angular/core';
import { SessionService } from '@monsido/core/session/session.service';

@Pipe({
    name: 'accessibilityCloseCaption',
    standalone: false,
})
export class AccessibilityCloseCaptionPipe implements PipeTransform {
    private readonly checksCloseCaption = [17, 20, 77, 145, 146];

    constructor (private sessionService: SessionService) {}

    transform (check: any): boolean {
        const checkObj = check || {};

        if (typeof checkObj.id !== 'number') {
            return false;
        }

        return this.checksCloseCaption.indexOf(checkObj.id) > -1 && this.hasCloseCaption();
    }

    private hasCloseCaption (): boolean {
        if (this.sessionService.customer === null) {
            return false;
        }

        return Boolean(this.sessionService.customer?.plan_traits?.closed_caption);
    }
}
